import {
    REQUEST_UPDATE_MANAGER_PERSON, REQUEST_UPDATE_MANAGER_PERSON_FAILURE,
    REQUEST_UPDATE_MANAGER_PERSON_SUCCESS
} from "../../../constant/master/TransManagerPersonConstant";

const initialState = {
    updateManagerPerson: {
        data: [],
        status: 'idle',
        isLoading: true,
    },
};


export const updateManagerPersonReducer = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case REQUEST_UPDATE_MANAGER_PERSON:
            return {
                ...state,
                updateManagerPerson: {
                    data: [],
                    status: 'fetching',
                    isLoading: true,
                },
            };
        case REQUEST_UPDATE_MANAGER_PERSON_SUCCESS:
            return {
                ...state,
                updateManagerPerson: {
                    data: payload,
                    status: 'ready',
                    isLoading: false,
                },
            };
        case REQUEST_UPDATE_MANAGER_PERSON_FAILURE:
            return {
                ...state,
                updateManagerPerson: {
                    data: [],
                    status: 'fetching',
                },
            };
        default:
            return state;
    }
}
